import * as React from 'react';

interface IProps {
  rootElementRef: React.RefObject<HTMLDivElement>;
  targetElementRef: React.RefObject<HTMLDivElement>;
  handler: () => void;
}

export const useObserver = ({ rootElementRef, targetElementRef, handler }: IProps) => {
  const observer = React.useMemo(() => {
    return new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handler();
        }
      },
      {
        root: rootElementRef.current,
        rootMargin: '200px',
        threshold: 0,
      },
    );
  }, [rootElementRef, handler]);

  React.useEffect(() => {
    if (targetElementRef.current && observer) {
      observer.observe(targetElementRef.current);
    }

    return () => observer && observer.disconnect();
  }, [observer, targetElementRef]);
};
